import React from 'react';
import './Stats.css';

const Stats = () => {
  // Hardcoded premium startup metrics that attract business owners, tech clients, and partners
  const startupStats = [
    { value: "99%", label: "Client Satisfaction", suffix: "" },
    { value: "50", label: "Projects Delivered", suffix: "+" },
    { value: "24/7", label: "Dedicated Support", suffix: "" },
    { value: "400", label: "Hours Saved / Mo", suffix: "K+" }
  ];

  return (
    <section className="stats-section">
      <div className="container">
        <div className="stats-grid">
          {startupStats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-number">
                {stat.value}
                <span className="stat-suffix">{stat.suffix}</span>
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;